@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.mpay_qr_scan.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.mpay_qr_scan.generated.resources/"

internal val Res.string.feature_qr_approve_permission_description_camera: StringResource by lazy {
      StringResource("string:feature_qr_approve_permission_description_camera", "feature_qr_approve_permission_description_camera", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 148),
      ))
    }

internal val Res.string.feature_qr_camera_access_denied: StringResource by lazy {
      StringResource("string:feature_qr_camera_access_denied", "feature_qr_camera_access_denied", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 155, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159, 67),
      ))
    }

internal val Res.string.feature_qr_camera_denied_message: StringResource by lazy {
      StringResource("string:feature_qr_camera_denied_message", "feature_qr_camera_denied_message", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 235, 236),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 227, 176),
      ))
    }

internal val Res.string.feature_qr_camera_error: StringResource by lazy {
      StringResource("string:feature_qr_camera_error", "feature_qr_camera_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 472, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 404, 47),
      ))
    }

internal val Res.string.feature_qr_camera_permission_description: StringResource by lazy {
      StringResource("string:feature_qr_camera_permission_description", "feature_qr_camera_permission_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 532, 228),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 452, 168),
      ))
    }

internal val Res.string.feature_qr_camera_permission_title: StringResource by lazy {
      StringResource("string:feature_qr_camera_permission_title", "feature_qr_camera_permission_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 761, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 621, 74),
      ))
    }

internal val Res.string.feature_qr_camera_settings_hint: StringResource by lazy {
      StringResource("string:feature_qr_camera_settings_hint", "feature_qr_camera_settings_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 848, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 696, 147),
      ))
    }

internal val Res.string.feature_qr_camera_view_active: StringResource by lazy {
      StringResource("string:feature_qr_camera_view_active", "feature_qr_camera_view_active", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1032, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 844, 61),
      ))
    }

internal val Res.string.feature_qr_close: StringResource by lazy {
      StringResource("string:feature_qr_close", "feature_qr_close", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1102, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 906, 32),
      ))
    }

internal val Res.string.feature_qr_dismiss: StringResource by lazy {
      StringResource("string:feature_qr_dismiss", "feature_qr_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1135, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 939, 38),
      ))
    }

internal val Res.string.feature_qr_drag_drop_hint: StringResource by lazy {
      StringResource("string:feature_qr_drag_drop_hint", "feature_qr_drag_drop_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1174, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 978, 73),
      ))
    }

internal val Res.string.feature_qr_drop_image_here: StringResource by lazy {
      StringResource("string:feature_qr_drop_image_here", "feature_qr_drop_image_here", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1256, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1052, 54),
      ))
    }

internal val Res.string.feature_qr_help: StringResource by lazy {
      StringResource("string:feature_qr_help", "feature_qr_help", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1697, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1445, 31),
      ))
    }

internal val Res.string.feature_qr_help_description: StringResource by lazy {
      StringResource("string:feature_qr_help_description", "feature_qr_help_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1323, 307),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1107, 287),
      ))
    }

internal val Res.string.feature_qr_help_title: StringResource by lazy {
      StringResource("string:feature_qr_help_title", "feature_qr_help_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1631, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1395, 49),
      ))
    }

internal val Res.string.feature_qr_import_description: StringResource by lazy {
      StringResource("string:feature_qr_import_description", "feature_qr_import_description", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1729, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1477, 141),
      ))
    }

internal val Res.string.feature_qr_import_qr_code: StringResource by lazy {
      StringResource("string:feature_qr_import_qr_code", "feature_qr_import_qr_code", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1907, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1619, 53),
      ))
    }

internal val Res.string.feature_qr_initializing_camera: StringResource by lazy {
      StringResource("string:feature_qr_initializing_camera", "feature_qr_initializing_camera", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1969, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1673, 70),
      ))
    }

internal val Res.string.feature_qr_instruction: StringResource by lazy {
      StringResource("string:feature_qr_instruction", "feature_qr_instruction", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2036, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1744, 130),
      ))
    }

internal val Res.string.feature_qr_loading: StringResource by lazy {
      StringResource("string:feature_qr_loading", "feature_qr_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2187, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1875, 38),
      ))
    }

internal val Res.string.feature_qr_no_qr_found: StringResource by lazy {
      StringResource("string:feature_qr_no_qr_found", "feature_qr_no_qr_found", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2226, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1914, 82),
      ))
    }

internal val Res.string.feature_qr_ok: StringResource by lazy {
      StringResource("string:feature_qr_ok", "feature_qr_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2337, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1997, 25),
      ))
    }

internal val Res.string.feature_qr_oops: StringResource by lazy {
      StringResource("string:feature_qr_oops", "feature_qr_oops", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2371, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2023, 31),
      ))
    }

internal val Res.string.feature_qr_open_settings: StringResource by lazy {
      StringResource("string:feature_qr_open_settings", "feature_qr_open_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2403, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2055, 52),
      ))
    }

internal val Res.string.feature_qr_permission_required: StringResource by lazy {
      StringResource("string:feature_qr_permission_required", "feature_qr_permission_required", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2464, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2108, 66),
      ))
    }

internal val Res.string.feature_qr_position_qr_code: StringResource by lazy {
      StringResource("string:feature_qr_position_qr_code", "feature_qr_position_qr_code", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2527, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2175, 87),
      ))
    }

internal val Res.string.feature_qr_powered_by: StringResource by lazy {
      StringResource("string:feature_qr_powered_by", "feature_qr_powered_by", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2619, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2263, 53),
      ))
    }

internal val Res.string.feature_qr_preview_image: StringResource by lazy {
      StringResource("string:feature_qr_preview_image", "feature_qr_preview_image", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2681, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2317, 68),
      ))
    }

internal val Res.string.feature_qr_proceed: StringResource by lazy {
      StringResource("string:feature_qr_proceed", "feature_qr_proceed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2766, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2386, 38),
      ))
    }

internal val Res.string.feature_qr_processing: StringResource by lazy {
      StringResource("string:feature_qr_processing", "feature_qr_processing", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2805, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2425, 57),
      ))
    }

internal val Res.string.feature_qr_scan_any_qr: StringResource by lazy {
      StringResource("string:feature_qr_scan_any_qr", "feature_qr_scan_any_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2867, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2483, 46),
      ))
    }

internal val Res.string.feature_qr_scan_code: StringResource by lazy {
      StringResource("string:feature_qr_scan_code", "feature_qr_scan_code", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2926, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2530, 40),
      ))
    }

internal val Res.string.feature_qr_scan_qr_code: StringResource by lazy {
      StringResource("string:feature_qr_scan_qr_code", "feature_qr_scan_qr_code", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2979, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2571, 47),
      ))
    }

internal val Res.string.feature_qr_scan_success: StringResource by lazy {
      StringResource("string:feature_qr_scan_success", "feature_qr_scan_success", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3039, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2619, 71),
      ))
    }

internal val Res.string.feature_qr_scan_valid_qr: StringResource by lazy {
      StringResource("string:feature_qr_scan_valid_qr", "feature_qr_scan_valid_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3115, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2691, 60),
      ))
    }

internal val Res.string.feature_qr_select_from_gallery: StringResource by lazy {
      StringResource("string:feature_qr_select_from_gallery", "feature_qr_select_from_gallery", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3188, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2752, 66),
      ))
    }

internal val Res.string.feature_qr_select_image: StringResource by lazy {
      StringResource("string:feature_qr_select_image", "feature_qr_select_image", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3263, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2819, 47),
      ))
    }

internal val Res.string.feature_qr_select_qr_image: StringResource by lazy {
      StringResource("string:feature_qr_select_qr_image", "feature_qr_select_qr_image", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3319, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2867, 62),
      ))
    }

internal val Res.string.feature_qr_supported_formats: StringResource by lazy {
      StringResource("string:feature_qr_supported_formats", "feature_qr_supported_formats", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3398, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2930, 80),
      ))
    }

internal val Res.string.feature_qr_supported_transfers: StringResource by lazy {
      StringResource("string:feature_qr_supported_transfers", "feature_qr_supported_transfers", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3483, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3011, 74),
      ))
    }

internal val Res.string.feature_qr_toggle_flash: StringResource by lazy {
      StringResource("string:feature_qr_toggle_flash", "feature_qr_toggle_flash", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3566, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3086, 55),
      ))
    }

internal val Res.string.feature_qr_torch: StringResource by lazy {
      StringResource("string:feature_qr_torch", "feature_qr_torch", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3630, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3142, 32),
      ))
    }

internal val Res.string.feature_qr_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_qr_unexpected_error_subtitle", "feature_qr_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3667, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3175, 108),
      ))
    }

internal val Res.string.feature_qr_upload_qr: StringResource by lazy {
      StringResource("string:feature_qr_upload_qr", "feature_qr_upload_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3796, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3284, 40),
      ))
    }

internal val Res.string.feature_qr_viewfinder: StringResource by lazy {
      StringResource("string:feature_qr_viewfinder", "feature_qr_viewfinder", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3837, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3325, 53),
      ))
    }

internal val Res.string.feature_qr_warning_message: StringResource by lazy {
      StringResource("string:feature_qr_warning_message", "feature_qr_warning_message", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 3895, 446),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3379, 358),
      ))
    }

internal val Res.string.feature_qr_warning_title: StringResource by lazy {
      StringResource("string:feature_qr_warning_title", "feature_qr_warning_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4342, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3738, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_qr_approve_permission_description_camera", Res.string.feature_qr_approve_permission_description_camera)
  map.put("feature_qr_camera_access_denied", Res.string.feature_qr_camera_access_denied)
  map.put("feature_qr_camera_denied_message", Res.string.feature_qr_camera_denied_message)
  map.put("feature_qr_camera_error", Res.string.feature_qr_camera_error)
  map.put("feature_qr_camera_permission_description", Res.string.feature_qr_camera_permission_description)
  map.put("feature_qr_camera_permission_title", Res.string.feature_qr_camera_permission_title)
  map.put("feature_qr_camera_settings_hint", Res.string.feature_qr_camera_settings_hint)
  map.put("feature_qr_camera_view_active", Res.string.feature_qr_camera_view_active)
  map.put("feature_qr_close", Res.string.feature_qr_close)
  map.put("feature_qr_dismiss", Res.string.feature_qr_dismiss)
  map.put("feature_qr_drag_drop_hint", Res.string.feature_qr_drag_drop_hint)
  map.put("feature_qr_drop_image_here", Res.string.feature_qr_drop_image_here)
  map.put("feature_qr_help", Res.string.feature_qr_help)
  map.put("feature_qr_help_description", Res.string.feature_qr_help_description)
  map.put("feature_qr_help_title", Res.string.feature_qr_help_title)
  map.put("feature_qr_import_description", Res.string.feature_qr_import_description)
  map.put("feature_qr_import_qr_code", Res.string.feature_qr_import_qr_code)
  map.put("feature_qr_initializing_camera", Res.string.feature_qr_initializing_camera)
  map.put("feature_qr_instruction", Res.string.feature_qr_instruction)
  map.put("feature_qr_loading", Res.string.feature_qr_loading)
  map.put("feature_qr_no_qr_found", Res.string.feature_qr_no_qr_found)
  map.put("feature_qr_ok", Res.string.feature_qr_ok)
  map.put("feature_qr_oops", Res.string.feature_qr_oops)
  map.put("feature_qr_open_settings", Res.string.feature_qr_open_settings)
  map.put("feature_qr_permission_required", Res.string.feature_qr_permission_required)
  map.put("feature_qr_position_qr_code", Res.string.feature_qr_position_qr_code)
  map.put("feature_qr_powered_by", Res.string.feature_qr_powered_by)
  map.put("feature_qr_preview_image", Res.string.feature_qr_preview_image)
  map.put("feature_qr_proceed", Res.string.feature_qr_proceed)
  map.put("feature_qr_processing", Res.string.feature_qr_processing)
  map.put("feature_qr_scan_any_qr", Res.string.feature_qr_scan_any_qr)
  map.put("feature_qr_scan_code", Res.string.feature_qr_scan_code)
  map.put("feature_qr_scan_qr_code", Res.string.feature_qr_scan_qr_code)
  map.put("feature_qr_scan_success", Res.string.feature_qr_scan_success)
  map.put("feature_qr_scan_valid_qr", Res.string.feature_qr_scan_valid_qr)
  map.put("feature_qr_select_from_gallery", Res.string.feature_qr_select_from_gallery)
  map.put("feature_qr_select_image", Res.string.feature_qr_select_image)
  map.put("feature_qr_select_qr_image", Res.string.feature_qr_select_qr_image)
  map.put("feature_qr_supported_formats", Res.string.feature_qr_supported_formats)
  map.put("feature_qr_supported_transfers", Res.string.feature_qr_supported_transfers)
  map.put("feature_qr_toggle_flash", Res.string.feature_qr_toggle_flash)
  map.put("feature_qr_torch", Res.string.feature_qr_torch)
  map.put("feature_qr_unexpected_error_subtitle", Res.string.feature_qr_unexpected_error_subtitle)
  map.put("feature_qr_upload_qr", Res.string.feature_qr_upload_qr)
  map.put("feature_qr_viewfinder", Res.string.feature_qr_viewfinder)
  map.put("feature_qr_warning_message", Res.string.feature_qr_warning_message)
  map.put("feature_qr_warning_title", Res.string.feature_qr_warning_title)
}
